export class TableFiltersWrapperComponent {
    filtersOpen = !this.isMobile;

    get isMobile() {
        return window.innerWidth <= 1200;
    }
}

angular.module('tradersyard').component('tyTableFiltersWrapper', {
    // language=HTML
    template: `
        <div is-uib>
            <div class="row">
                <div class="col-xs-12" ng-if="$ctrl.isMobile">
                    <div class="form-group">
                        <button class="btn btn-default" ng-click="$ctrl.filtersOpen = !$ctrl.filtersOpen">
                            <i class="fa fa-filter"></i> Filter
                        </button>
                    </div>
                </div>
            </div>
            <div ng-show="$ctrl.filtersOpen" class="row">
                <ng-transclude/>
            </div>
        </div>`,
    controller: TableFiltersWrapperComponent,
    transclude: true,
});
